import React from "react";
import { Link } from "react-router-dom";
import { pageUrl } from "../constant/pageurl";
import { Bubble } from "../layouts/animation/Bubble";
import "./success.css";

export const Success = () => {
  return (
    <div className="success-page">
      <h1>Thanks for upgrading</h1>
      <p>A receipt has been sent to your email address</p>
      <Link to={pageUrl.DASHBOARD}>Goto dashboard</Link>

      <Bubble />
      <Bubble two={"two"} />
    </div>
  );
};
